import React, { useState, useEffect } from 'react';
import { Layout, Form, Input, Button, Select, Collapse, Modal, List, message } from 'antd';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { apiUrl } from './config';
import { useUser } from '../context/UserContext';
import { PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';

const { Content } = Layout;
const { Panel } = Collapse;
const { Option } = Select;

const muscleGroups = [
    {
        group: 'Gambe',
        exercises: [
            { id: 1, name: 'Squat', muscleGroup: 'Gambe', image: 'images/exercise/squat.jpg', video: "https://www.youtube.com/watch?v=ThD3d6kNjuA" },
            { id: 2, name: 'Leg Press', muscleGroup: 'Gambe', image: 'images/exercise/leg-press.jpg', video: 'https://www.youtube.com/watch?v=uEsZWWiYNAQ' },
            { id: 3, name: 'Leg Extension', muscleGroup: 'Gambe', image: 'images/exercise/leg-extension.jpg', video: 'https://www.youtube.com/watch?v=4ZDm5EbiFI8' },
            { id: 4, name: 'Leg Curl', muscleGroup: 'Gambe', image: 'images/exercise/leg-curl.jpg', video: 'https://www.youtube.com/watch?v=SiwJ_T62l9c' },
            { id: 5, name: 'Affondi', muscleGroup: 'Gambe', image: 'images/exercise/affondi.jpg', video: 'https://www.youtube.com/watch?v=vaX0OAantK0' },
            { id: 6, name: 'Adductor', muscleGroup: 'Gambe', image: 'images/exercise/adductor.jpg', video: 'https://www.youtube.com/watch?v=SU1LQhq3o2g' },
            { id: 7, name: 'Abductor', muscleGroup: 'Gambe', image: 'images/exercise/abductor.jpg', video: 'https://www.youtube.com/watch?v=V7YHfRT2PLE' },
            { id: 8, name: 'Calf Sitting', muscleGroup: 'Gambe', image: 'images/exercise/calf.jpg', video: 'https://www.youtube.com/watch?v=HSGjUouQZCQ' },
            { id: 112, name: 'Calf Standing', muscleGroup: 'Gambe', image: 'images/exercise/calf-standing.jpg', video: 'https://www.youtube.com/watch?v=cHec9m_BotY' },
            { id: 50, name: 'Affondi Bulgari', muscleGroup: 'Gambe', image: 'images/exercise/affondi-bulgari.jpg', video: 'https://www.youtube.com/watch?v=QbTG88wAcSo' },
            { id: 49, name: 'Slanci ai Cavi', muscleGroup: 'Gambe', image: 'images/exercise/slanci.jpg', video: 'https://www.youtube.com/watch?v=SlUzD2521sM' },
            { id: 76, name: 'Affondi Posteriori', muscleGroup: 'Gambe', image: 'images/exercise/affondi-indietro.jpg', video: 'https://www.youtube.com/watch?v=umt9t9jd6Zw' },
            { id: 79, name: 'Hack Squat', muscleGroup: 'Gambe', image: 'images/exercise/hack-squat.jpg', video: 'https://www.youtube.com/watch?v=8AXtP_CHO4k' },
            { id: 80, name: 'Hip Thrust', muscleGroup: 'Gambe', image: 'images/exercise/hip-thrust.jpg', video: 'https://www.youtube.com/watch?v=5S8SApGU_Lk' },
            { id: 85, name: 'Russian Swing', muscleGroup: 'Gambe', image: 'images/exercise/russian-swing.jpg', video: 'https://www.youtube.com/watch?v=RU88iqRVunk' },
            { id: 86, name: 'Squat al Multipower', muscleGroup: 'Gambe', image: 'images/exercise/squat-mp.jpg', video: 'https://www.youtube.com/watch?v=mG45EaBp2C4' },
            { id: 88, name: 'Stacchi da Terra', muscleGroup: 'Gambe', image: 'images/exercise/stacchi-gambe.jpg', video: 'https://www.youtube.com/watch?v=b4NI-OkEnW0' },
            { id: 89, name: 'Stacchi Rumeni', muscleGroup: 'Gambe', image: 'images/exercise/stacchi-rumeni.jpg', video: 'https://www.youtube.com/watch?v=_P3WyVBuSwA' },
            { id: 90, name: 'Step Up', muscleGroup: 'Gambe', image: 'images/exercise/step-up.jpg', video: 'https://www.youtube.com/watch?v=AsppUFDOQbI' },
            { id: 115, name: 'Frog Pump', muscleGroup: 'Gambe', image: 'images/exercise/frog-pump.jpeg', video: 'https://www.youtube.com/watch?v=MQ62r2V7Lw8' },
            { id: 116, name: 'Wall Sit', muscleGroup: 'Gambe', image: 'images/exercise/wall-sit.jpg', video: 'https://www.youtube.com/watch?v=cWTZ8Am1Ee0' }
        ]
    },
    {
        group: 'Pettorali',
        exercises: [
            { id: 9, name: 'Panca Piana', muscleGroup: 'Pettorali', image: 'images/exercise/panca-piana.jpg', video: 'https://www.youtube.com/watch?v=kWrRwATrqpc' },
            { id: 10, name: 'Panca Inclinata', muscleGroup: 'Pettorali', image: 'images/exercise/panca-inclinata.jpg', video: 'https://www.youtube.com/watch?v=AJkXfkYVX2o' },
            { id: 11, name: 'Spinte Panca Piana', muscleGroup: 'Pettorali', image: 'images/exercise/panca-manubri.jpg', video: 'https://www.youtube.com/watch?v=ON0D6MmOVDo' },
            { id: 48, name: 'Spinte Panca Inclinata', muscleGroup: 'Pettorali', image: 'images/exercise/panca-inclinata-manubri.jpg', video: 'https://www.youtube.com/watch?v=iKRv8OOtwAs' },
            { id: 12, name: 'Aperture Panca Manubri', muscleGroup: 'Pettorali', image: 'images/exercise/aperture-manubri.jpg', video: 'https://www.youtube.com/watch?v=PwirQ3nclDw' },
            { id: 13, name: 'Pectoral Machine', muscleGroup: 'Pettorali', image: 'images/exercise/pec-fly.jpg', video: 'https://www.youtube.com/watch?v=eGjt4lk6g34' },
            { id: 14, name: 'Chest Press', muscleGroup: 'Pettorali', image: 'images/exercise/chest-press.jpg', video: 'https://www.youtube.com/watch?v=sqNwDkUU_Ps' },
            { id: 15, name: 'Cavi dall\'alto', muscleGroup: 'Pettorali', image: 'images/exercise/cavi-petto.jpg', video: 'https://www.youtube.com/watch?v=J02PvLa_9Ks' },
            { id: 77, name: 'Cavi dal basso', muscleGroup: 'Pettorali', image: 'images/exercise/cavi-dal-basso.jpg', video: 'https://www.youtube.com/watch?v=ADGMLX20Cgc' },
            { id: 16, name: 'Dip', muscleGroup: 'Pettorali', image: 'images/exercise/dip.jpg', video: 'https://www.youtube.com/watch?v=rXeyNuQ58wU' }
        ]
    },
    {
        group: 'Dorsali',
        exercises: [
            { id: 17, name: 'Lat Machine', muscleGroup: 'Dorsali', image: 'images/exercise/lat-machine.jpg', video: 'https://www.youtube.com/watch?v=EOsjNqfkxRU' },
            { id: 18, name: 'Sbarra', muscleGroup: 'Dorsali', image: 'images/exercise/pull-up.jpg', video: 'https://www.youtube.com/watch?v=eGo4IYlbE5g' },
            { id: 113, name: 'Chin Up', muscleGroup: 'Dorsali', image: 'images/exercise/chin-up.jpg', video: 'https://www.youtube.com/watch?v=xBzKgvYBxI4' },
            { id: 19, name: 'Pulley Machine', muscleGroup: 'Dorsali', image: 'images/exercise/pulley.jpg', video: 'https://www.youtube.com/watch?v=ibsA8hmC4U4' },
            { id: 20, name: 'Vertical Traction', muscleGroup: 'Dorsali', image: 'images/exercise/vertical.jpg', video: 'https://www.youtube.com/watch?v=89VvRXmIj38' },
            { id: 21, name: 'Rematore Bilanciere', muscleGroup: 'Dorsali', image: 'images/exercise/rematore-bilancere.jpg', video: 'https://www.youtube.com/watch?v=tM5zEOnBNZc' },
            { id: 22, name: 'Rematore Manubri', muscleGroup: 'Dorsali', image: 'images/exercise/rematore-manubri.jpg', video: 'https://www.youtube.com/watch?v=1e-Ks7gpp44' },
            { id: 23, name: 'Hyperextension', muscleGroup: 'Dorsali', image: 'images/exercise/hyperextension.jpg', video: 'https://www.youtube.com/watch?v=qw1fAjGNFOY' },
            { id: 51, name: 'T-Bar', muscleGroup: 'Dorsali', image: 'images/exercise/t-bar.jpg', video: 'https://www.youtube.com/watch?v=BVSTYt02SuY' },
            { id: 81, name: 'Iliac Pulldown', muscleGroup: 'Dorsali', image: 'images/exercise/iliac.jpg', video: 'https://www.youtube.com/watch?v=VBeIkJQMXF4' },
            { id: 84, name: 'Pulldown', muscleGroup: 'Dorsali', image: 'images/exercise/pulldown.jpg', video: 'https://www.youtube.com/watch?v=4WCVESSe3Ow' },
            { id: 87, name: 'Stacchi da Terra', muscleGroup: 'Dorsali', image: 'images/exercise/stacchi-dorso.jpg', video: 'https://www.youtube.com/watch?v=b4NI-OkEnW0' },
            { id: 91, name: 'Vertical Row', muscleGroup: 'Dorsali', image: 'images/exercise/vertical-row.jpg', video: 'https://www.youtube.com/watch?v=jBlunMD5MZs' },
            { id: 114, name: 'Australian Pull Up', muscleGroup: 'Dorsali', image: 'images/exercise/australian-pull-up.jpg', video: 'https://www.youtube.com/watch?v=bHO0A4ZF_Zg' }
        ]
    },
    {
        group: 'Spalle',
        exercises: [
            { id: 24, name: 'Shoulder Press Manubri', muscleGroup: 'Spalle', image: 'images/exercise/shoulder-manubri.jpg', video: 'https://www.youtube.com/watch?v=hOTABpGvhBc' },
            { id: 25, name: 'Shoulder Press Multipower', muscleGroup: 'Spalle', image: 'images/exercise/shoulder-multipower.jpg', video: 'https://www.youtube.com/watch?v=OLqZDUUD2b0' },
            { id: 26, name: 'Alzate Laterali', muscleGroup: 'Spalle', image: 'images/exercise/alzate-laterali.jpg', video: 'https://www.youtube.com/watch?v=XPPfnSEATJA' },
            { id: 27, name: 'Alzate 90°', muscleGroup: 'Spalle', image: 'images/exercise/alzate-90.jpg', video: 'https://www.youtube.com/watch?v=TP1SPu3QWsU' },
            { id: 28, name: 'Shoulder Press', muscleGroup: 'Spalle', image: 'images/exercise/shoulder-press.jpg', video: 'https://www.youtube.com/watch?v=WvLMauqrnK8' },
            { id: 29, name: 'Alzate Frontali', muscleGroup: 'Spalle', image: 'images/exercise/alzate-frontali.jpg', video: 'https://www.youtube.com/watch?v=hRJ6tR5-if0' },
            { id: 30, name: 'Scrollate', muscleGroup: 'Spalle', image: 'images/exercise/scrollate.jpg', video: 'https://www.youtube.com/watch?v=xsadROP_MXw' },
            { id: 78, name: 'Croci Inverse ai Cavi', muscleGroup: 'Spalle', image: 'images/exercise/croci-inverse.jpg', video: 'https://www.youtube.com/watch?v=nbSRz5JwH5Y' },
            { id: 82, name: 'Military Press', muscleGroup: 'Spalle', image: 'images/exercise/military-press.jpg', video: 'https://www.youtube.com/watch?v=43GSKivZnw4' },
            { id: 83, name: 'Pull Face', muscleGroup: 'Spalle', image: 'images/exercise/pull-face.jpg', video: 'https://www.youtube.com/watch?v=0Po47vvj9g4' },
            { id: 82, name: '6 Ways con Manubri', muscleGroup: 'Spalle', image: 'images/exercise/alzate-360.png', video: 'https://www.youtube.com/watch?v=pZyc0kVIjOw' },
        ]
    },
    {
        group: 'Bicipiti',
        exercises: [
            { id: 31, name: 'Curl Bilanciere', muscleGroup: 'Bicipiti', image: 'images/exercise/curl-bicipiti.jpg', video: 'https://www.youtube.com/watch?v=7ECvCFpsOik' },
            { id: 32, name: 'Panca Scott', muscleGroup: 'Bicipiti', image: 'images/exercise/panca-scott.jpg', video: 'https://www.youtube.com/watch?v=TlJtGMAGkI4' },
            { id: 33, name: 'Concentrato', muscleGroup: 'Bicipiti', image: 'images/exercise/concentrato.jpg', video: 'https://www.youtube.com/watch?v=neSxDNWz8WU' },
            { id: 34, name: 'Manubri', muscleGroup: 'Bicipiti', image: 'images/exercise/bicipiti-manubri.jpg', video: 'https://www.youtube.com/watch?v=1Qp04kK-k6U' },
            { id: 35, name: 'Cavo Basso', muscleGroup: 'Bicipiti', image: 'images/exercise/bicipiti-cavi.jpg', video: 'https://www.youtube.com/watch?v=UsY8ixNZ5qE' },
            { id: 53, name: 'Bayesian Curl', muscleGroup: 'Bicipiti', image: 'images/exercise/bayesian.jpg', video: 'https://www.youtube.com/watch?v=VPmJ-OpCoyY' },
            { id: 58, name: 'Curl Bilanciere Panca 45°', muscleGroup: 'Bicipiti', image: 'images/exercise/curl-panca-45.jpg', video: 'https://www.youtube.com/watch?v=zy1-OMZZJtk' },
            { id: 59, name: 'Curl Manubri Panca 45°', muscleGroup: 'Bicipiti', image: 'images/exercise/concentrato-bicipiti.jpg', video: 'https://www.youtube.com/watch?v=rr2meFMsgSY' },
            { id: 59, name: 'Curl TRX', muscleGroup: 'Bicipiti', image: 'images/exercise/curl-trx.jpg', video: 'https://www.youtube.com/watch?v=xG57S0fgXAk' },
            { id: 67, name: 'Preacher Curl', muscleGroup: 'Bicipiti', image: 'images/exercise/preacher-machine.jpg', video: 'https://www.youtube.com/watch?v=Ja6ZlIDONacs' }
        ]
    },
    {
        group: 'Tricipiti',
        exercises: [
            { id: 36, name: 'Push Down', muscleGroup: 'Tricipiti', image: 'images/exercise/push-down.jpg', video: 'https://www.youtube.com/watch?v=lt3YQIM88Ho' },
            { id: 38, name: 'French Press Bilancere', muscleGroup: 'Tricipiti', image: 'images/exercise/frenchpress.jpg', video: 'https://www.youtube.com/watch?v=HEmZVzk-t_Y' },
            { id: 39, name: 'French Press Manubri', muscleGroup: 'Tricipiti', image: 'images/exercise/french-press-manubri.jpg', video: 'https://www.youtube.com/watch?v=vS_lKYyyWkA' },
            { id: 54, name: 'Concentrato Doppio', muscleGroup: 'Tricipiti', image: 'images/exercise/concentrato-doppio.jpg', video: 'https://www.youtube.com/watch?v=a9oPnZReIRE' },
            { id: 55, name: 'Concentrato Singolo', muscleGroup: 'Tricipiti', image: 'images/exercise/concentrato-singolo.jpg', video: 'https://www.youtube.com/watch?v=kZ-ReOdn2qk' },
            { id: 60, name: 'Dip su panca', muscleGroup: 'Tricipiti', image: 'images/exercise/dip-panca.jpg', video: 'https://www.youtube.com/watch?v=w0IGXuYFbZo' },
            { id: 65, name: 'Overhead Extension', muscleGroup: 'Tricipiti', image: 'images/exercise/overhead.jpg', video: 'https://www.youtube.com/watch?v=kqidUIf1eJE' },
            { id: 66, name: 'Panca Stretta Multipower', muscleGroup: 'Tricipiti', image: 'images/exercise/panca-stretta-mp.jpg', video: 'https://www.youtube.com/watch?v=en8YGNoPO80' },
            { id: 66, name: 'Panca Stretta', muscleGroup: 'Tricipiti', image: 'images/exercise/panca-stretta.png', video: 'https://www.youtube.com/watch?v=HJ_2z0qVXgA' },
            { id: 93, name: 'Dip Parallele', muscleGroup: 'Tricipiti', image: 'images/exercise/dip.jpg', video: 'https://www.youtube.com/watch?v=icpXxcL2N30' }
        ]
    },
    {
        group: 'Addominali',
        exercises: [
            { id: 40, name: 'Crunch', muscleGroup: 'Addominali', image: 'images/exercise/crunch.jpg', video: 'https://www.youtube.com/watch?v=O0pIQ2UqeCY' },
            { id: 41, name: 'Leg Raise', muscleGroup: 'Addominali', image: 'images/exercise/leg-raise.jpg', video: 'https://www.youtube.com/watch?v=Cwuxy8eo7iw' },
            { id: 42, name: 'Plank', muscleGroup: 'Addominali', image: 'images/exercise/plank.jpg', video: 'https://www.youtube.com/watch?v=pvIjsG5Svck&t=2s' },
            { id: 56, name: 'Criss Cross', muscleGroup: 'Addominali', image: 'images/exercise/criss-cross.jpg', video: 'https://www.youtube.com/watch?v=4qZjoAl8x8c' },
            { id: 57, name: 'Crunch Fitball', muscleGroup: 'Addominali', image: 'images/exercise/crunch-fitball.jpg', video: 'https://www.youtube.com/watch?v=O4d3kd1ZLyc' },
            { id: 62, name: 'Knee Raise', muscleGroup: 'Addominali', image: 'images/exercise/knee-raise.jpg', video: 'https://www.youtube.com/watch?v=KNzJ3GuIpB8' },
            { id: 63, name: 'Legs Raise su Sbarra', muscleGroup: 'Addominali', image: 'images/exercise/legs-raise.jpg', video: 'https://www.youtube.com/watch?v=RuIdJSVTKO4' },
            { id: 64, name: 'Mountain Climber', muscleGroup: 'Addominali', image: 'images/exercise/mountain-climber.jpg', video: 'https://www.youtube.com/watch?v=ruQ4ZwncXBg' },
            { id: 68, name: 'Crunch Inverso Fitball', muscleGroup: 'Addominali', image: 'images/exercise/reverse-crunch-fitball.jpg', video: 'https://www.youtube.com/watch?v=247-XF3kAT0' },
            { id: 69, name: 'Crunch Inverso', muscleGroup: 'Addominali', image: 'images/exercise/reverse-crunch.jpg', video: 'https://www.youtube.com/watch?v=YWnYd_8QzUE' },
            { id: 70, name: 'Russian Twist', muscleGroup: 'Addominali', image: 'images/exercise/russian-twist.jpg', video: 'https://www.youtube.com/watch?v=wkD8rjkodUI' },
            { id: 71, name: 'Side Plank', muscleGroup: 'Addominali', image: 'images/exercise/side-plank.jpg', video: 'https://www.youtube.com/watch?v=N_s9em1xTqU' },
            { id: 72, name: 'Sit Ups', muscleGroup: 'Addominali', image: 'images/exercise/sit-up.jpg', video: 'https://www.youtube.com/watch?v=swOyWKk7Oko' },
            { id: 73, name: 'V Ups', muscleGroup: 'Addominali', image: 'images/exercise/v-ups.jpg', video: 'https://www.youtube.com/watch?v=iP2fjvG0g3w' },
            { id: 74, name: 'Ankle Touch', muscleGroup: 'Addominali', image: 'images/exercise/ankle-touch.png', video: 'https://www.youtube.com/watch?v=6DqVnNnAUxU' }
        ]
    },
    {
        group: 'Cardio',
        exercises: [
            { id: 43, name: 'Tapis Roulant', muscleGroup: 'Cardio', image: 'images/exercise/tapis.jpg', video: 'https://www.youtube.com/watch?v=M46P-NR8Lw8' },
            { id: 44, name: 'Elliptical', muscleGroup: 'Cardio', image: 'images/exercise/ellittica.jpg', video: 'https://www.youtube.com/watch?v=YWfswVvOaiI' },
            { id: 45, name: 'Steps', muscleGroup: 'Cardio', image: 'images/exercise/steps.jpg', video: 'https://www.youtube.com/watch?v=xSB39wbMz4w' },
            { id: 46, name: 'Vogatore', muscleGroup: 'Cardio', image: 'images/exercise/vogatore.jpg', video: 'https://www.youtube.com/watch?v=6fpdBuUajIU&t=46s' },
            { id: 47, name: 'Cyclette', muscleGroup: 'Cardio', image: 'images/exercise/cyclette.jpg' },
            { id: 52, name: 'Assault Bike', muscleGroup: 'Cardio', image: 'images/exercise/assault-bike.jpg', video: 'https://www.youtube.com/watch?v=9xfUu652CMg' },
            { id: 61, name: 'Bike ERG', muscleGroup: 'Cardio', image: 'images/exercise/erg-bike.jpg', video: 'https://www.youtube.com/watch?v=DE9T22Q20Bw' },
            { id: 61, name: 'Ski ERG', muscleGroup: 'Cardio', image: 'images/exercise/ski-erg.png', video: 'https://www.youtube.com/watch?v=9Jqcxr8Iq5E' }
        ]
    },
    {
        group: 'Funzionali',
        exercises: [
            { id: 94, name: 'Burpees', muscleGroup: 'Funzionali', image: 'images/exercise/burpees.jpg', video: 'https://www.youtube.com/watch?v=auBLPXO8Fww' },
            { id: 95, name: 'Jump Squat', muscleGroup: 'Funzionali', image: 'images/exercise/jumpsquat.jpg', video: 'https://www.youtube.com/watch?v=BRfxI2Es2lE' },
            { id: 96, name: 'Push Up', muscleGroup: 'Funzionali', image: 'images/exercise/pushup.jpg', video: 'https://www.youtube.com/watch?v=JyCG_5l3XLk' },
            { id: 97, name: 'Goblet Squat', muscleGroup: 'Funzionali', image: 'images/exercise/goblet.jpg', video: 'https://www.youtube.com/watch?v=f-Vf2yRRqOg' },
            { id: 98, name: 'Skip', muscleGroup: 'Funzionali', image: 'images/exercise/skip.jpg', video: 'https://www.youtube.com/watch?v=-O9H15yVc8s' },
            { id: 99, name: 'Box Jump', muscleGroup: 'Funzionali', image: 'images/exercise/boxjump.jpg', video: 'https://www.youtube.com/watch?v=NBY9-kTuHEk' },
            { id: 100, name: 'Push Press', muscleGroup: 'Funzionali', image: 'images/exercise/pushpress.jpg', video: 'https://www.youtube.com/watch?v=iaBVSJm78ko' },
            { id: 101, name: 'Arm Swing', muscleGroup: 'Funzionali', image: 'images/exercise/armswing.jpg', video: 'https://www.youtube.com/watch?v=sxtfgmzhXvE' },
            { id: 102, name: 'Thruster', muscleGroup: 'Funzionali', image: 'images/exercise/thruster.jpg', video: 'https://www.youtube.com/watch?v=L219ltL15zk' },
            { id: 118, name: 'Single Under', muscleGroup: 'Funzionali', image: 'images/exercise/single-under.png', video: 'https://www.youtube.com/watch?v=hCuXYrTOMxI' },
            { id: 119, name: 'Wall Ball', muscleGroup: 'Funzionali', image: 'images/exercise/wall-ball.jpg', video: 'https://www.youtube.com/watch?v=fpUD0mcFp_0' },
            { id: 120, name: 'Frog Jump', muscleGroup: 'Funzionali', image: 'images/exercise/frog-jump.jpg', video: 'https://www.youtube.com/watch?v=1HXEiJBMdPE' },
            { id: 121, name: 'Burpees Broad Jump', muscleGroup: 'Funzionali', image: 'images/exercise/burpees-broad.jpg', video: 'https://www.youtube.com/watch?v=SkBe0YLKfXw' }
        ]
    },
    {
        group: 'Mobilità',
        exercises: [
            { id: 103, name: 'Mobilità Upper', muscleGroup: 'Mobilità', image: 'images/exercise/mobilitaupper.jpg', video: 'https://www.youtube.com/watch?v=9iHko2F81cE' },
            { id: 104, name: 'Mobilità Lower', muscleGroup: 'Mobilità', image: 'images/exercise/mobilitalower.jpg', video: 'https://www.youtube.com/watch?v=j9MOhBDIhuE' },
            { id: 105, name: 'Mobilità Total Body', muscleGroup: 'Mobilità', image: 'images/exercise/mobilitatotal.jpg', video: 'https://www.youtube.com/watch?v=WF88MJGikNU' },
            { id: 117, name: 'Mobilità Spalle', muscleGroup: 'Mobilità', image: 'images/exercise/mobilitaspalle.jpg', video: 'https://www.youtube.com/watch?v=oG5I8-rA3mU' },
        ]
    },
    {
        group: 'Stretching',
        exercises: [
            { id: 106, name: 'Stretching Lower', muscleGroup: 'Stretching', image: 'images/exercise/stretchinglower.jpg', video: 'https://www.youtube.com/watch?v=Aa5WNLBA4f4' },
            { id: 107, name: 'Stretching Upper', muscleGroup: 'Stretching', image: 'images/exercise/stratchingupper.jpg', video: 'https://www.youtube.com/watch?v=SnczdEkUBvg' },
            { id: 108, name: 'Stretching Total Body', muscleGroup: 'Stretching', image: 'images/exercise/stretchingtotal.jpg', video: 'https://www.youtube.com/watch?v=y87vSUoIMGU' },
            { id: 109, name: 'Stretching Spalle', muscleGroup: 'Stretching', image: 'images/exercise/stratchingspalle.jpg', video: 'https://www.youtube.com/watch?v=AxCxR9ChZeo' },
            { id: 110, name: 'Stretching Petto', muscleGroup: 'Stretching', image: 'images/exercise/stretchingpetto.jpg', video: 'https://www.youtube.com/watch?v=XdsRWiMPmfA' },
            { id: 111, name: 'Stretching Quadricipiti', muscleGroup: 'Stretching', image: 'images/exercise/stretchingquad.jpg', video: 'https://www.youtube.com/watch?v=R6t5tyYGaDg' }
        ]
    }
];

const folderOptions = [
    { value: 'beginner/woman', label: 'Beginner - Woman' },
    { value: 'beginner/men', label: 'Beginner - Men' },
    { value: 'intermediate/woman', label: 'Intermediate - Woman' },
    { value: 'intermediate/men', label: 'Intermediate - Men' },
    { value: 'advanced/woman', label: 'Advanced - Woman' },
    { value: 'advanced/men', label: 'Advanced - Men' },
    { value: 'workout of the day', label: 'Workout of the Day' },
    { value: 'functional training/woman', label: 'Functional Training - Woman' },
    { value: 'functional training/men', label: 'Functional Training - Men' },
    { value: 'only fundamentals', label: 'Only Fundamentals' },
    { value: 'over 60', label: 'Over 60+' }
];


// Filtra solo gli esercizi di Addominali e Cardio per la sezione fissa
const absExercises = muscleGroups.find(group => group.group === 'Addominali').exercises;
const cardioExercises = muscleGroups.find(group => group.group === 'Cardio').exercises;

const TrainerWorkoutForm = () => {
    const { id } = useParams();
    const { user } = useUser();
    const [workoutPlanName, setWorkoutPlanName] = useState('');
    const [selectedFolder, setSelectedFolder] = useState([]);
    const [numDays, setNumDays] = useState(0);
    const [duration, setDuration] = useState('');
    const [durationUnit, setDurationUnit] = useState('giorni');
    const [dayExercises, setDayExercises] = useState({});
    const [cardioAbsExercisesList, setCardioAbsExercisesList] = useState([]);
    const [exerciseModalVisible, setExerciseModalVisible] = useState(false);
    const [isCardioAbsModal, setIsCardioAbsModal] = useState(false); // Aggiungi uno stato per capire se il modal è per la sezione cardio/abs
    const [inputModalVisible, setInputModalVisible] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedExercise, setSelectedExercise] = useState(null);
    const [workoutPlanNotes, setWorkoutPlanNotes] = useState('');
    const [exerciseDetails, setExerciseDetails] = useState({
        numberExercise: '',
        series: '',
        reps: '',
        rest: '',
        note: '',
    });

    useEffect(() => {
        if (id) {
            fetchWorkoutPlan(id);
        }
    }, [id]);

    const removeDay = (dayToRemove) => {
        // Rimuovi il giorno specifico
        const updatedExercises = { ...dayExercises };
        delete updatedExercises[dayToRemove];

        // Riordina i giorni rimanenti
        const reorderedExercises = {};
        let newDayCounter = 1;
        Object.keys(updatedExercises).sort((a, b) => Number(a) - Number(b)).forEach(day => {
            reorderedExercises[newDayCounter] = updatedExercises[day];
            newDayCounter++;
        });

        // Aggiorna lo stato
        setDayExercises(reorderedExercises);
        setNumDays(newDayCounter - 1);
    };

    const fetchWorkoutPlan = async (planId) => {
        try {
            const response = await axios.get(`${apiUrl}/api/workoutPlans/${planId}`);
            const plan = response.data;
            setWorkoutPlanName(plan.workoutPlanName);
            setSelectedFolder(plan.folders || []);
            setWorkoutPlanNotes(plan.notes || ''); // Imposta le note
            setDuration(plan.duration.value || '');
            setDurationUnit(plan.duration.unit || '');

            const exercisesByDay = plan.exercises.reduce((acc, exercise) => {
                const day = exercise.day;
                if (!acc[day]) acc[day] = [];
                acc[day].push(exercise);
                return acc;
            }, {});

            setDayExercises(exercisesByDay);
            setNumDays(Object.keys(exercisesByDay).length);
        } catch (error) {
            message.error('Errore nel caricamento della scheda.');
        }
    };

    const handleFolderChange = (value) => setSelectedFolder(value);

    const handleNumDaysChange = (value) => {
        const updatedExercises = {};
        for (let i = 1; i <= value; i++) {
            updatedExercises[i] = dayExercises[i] || [];
        }
        setDayExercises(updatedExercises);
        setNumDays(value);
    };

    const openExerciseSelectionModal = (day, isCardioAbs = false) => {
        setSelectedDay(day);
        setIsCardioAbsModal(isCardioAbs); // Imposta il modal come "Cardio/Addominali" se è per quella sezione
        setExerciseModalVisible(true);
    };

    const selectExercise = (exercise) => {
        setSelectedExercise(exercise);
        setExerciseModalVisible(false);
        setInputModalVisible(true);
        const numberExercise = isCardioAbsModal
            ? cardioAbsExercisesList.length + 1
            : dayExercises[selectedDay]
                ? dayExercises[selectedDay].length + 1
                : 1;
        setExerciseDetails({
            numberExercise: numberExercise,
            series: '',
            reps: '',
            rest: '',
            note: '',
            video: exercise.video || '',
        });
    };

    const addExerciseToDay = () => {
        if ((!exerciseDetails.series || !exerciseDetails.reps) && !exerciseDetails.note) {
            message.error("Inserisci almeno il numero di serie o ripetizioni.");
            return;
        }
        if (selectedExercise) {
            const newExercise = {
                ...selectedExercise,
                ...exerciseDetails,
            };

            if (isCardioAbsModal) {
                // Per la sezione Cardio/Addominali
                setCardioAbsExercisesList(prev => {
                    // Rimuovi l'esercizio esistente se è già presente
                    const filteredList = prev.filter(ex => ex !== selectedExercise);

                    // Aggiungi il nuovo esercizio
                    const updatedList = [...filteredList, newExercise];

                    // Ordina in base al numero dell'esercizio
                    return updatedList.sort((a, b) =>
                        Number(a.numberExercise || 0) - Number(b.numberExercise || 0)
                    );
                });
            } else {
                // Per gli esercizi dei giorni
                setDayExercises((prev) => {
                    const dayExercisesList = prev[selectedDay] || [];

                    // Rimuovi l'esercizio esistente se è già presente
                    const filteredList = dayExercisesList.filter(ex => ex !== selectedExercise);

                    // Aggiungi il nuovo esercizio
                    const updatedList = [...filteredList, newExercise];

                    // Ordina in base al numero dell'esercizio
                    const sortedList = updatedList.sort((a, b) => {
                        // Converti a numero, se non è un numero usa 0
                        const numA = Number(a.numberExercise) || 0;
                        const numB = Number(b.numberExercise) || 0;
                        return numA - numB;
                    });

                    return {
                        ...prev,
                        [selectedDay]: sortedList
                    };
                });
            }

            setInputModalVisible(false);
            setSelectedExercise(null);
            setExerciseDetails({
                numberExercise: '',
                series: '',
                reps: '',
                rest: '',
                note: '',
            });
        }
    };

    const editExerciseInDay = (day, exerciseIndex, isCardioAbs = false) => {
        const exerciseToEdit = isCardioAbs
            ? cardioAbsExercisesList[exerciseIndex]
            : dayExercises[day][exerciseIndex];
        setSelectedDay(day);
        setSelectedExercise(exerciseToEdit);
        setExerciseDetails({
            numberExercise: exerciseToEdit.numberExercise,
            series: exerciseToEdit.series,
            reps: exerciseToEdit.reps,
            rest: exerciseToEdit.rest,
            note: exerciseToEdit.note,
        });
        setInputModalVisible(true);
    };

    const removeExerciseFromDay = (day, exerciseIndex, isCardioAbs = false) => {
        if (isCardioAbs) {
            setCardioAbsExercisesList(prev => prev.filter((_, index) => index !== exerciseIndex));
        } else {
            setDayExercises((prev) => ({
                ...prev,
                [day]: prev[day].filter((_, index) => index !== exerciseIndex),
            }));
        }
    };

    const handleSubmit = async () => {
        if (!workoutPlanName.trim()) {
            message.error('Devi inserire un nome per la scheda di allenamento.');
            return;
        }

        const exercises = Object.keys(dayExercises).flatMap((day) =>
            dayExercises[day].map((exercise) => ({
                name: exercise.name,
                series: exercise.series || '',
                reps: exercise.reps || '',
                rest: exercise.rest || '',
                note: exercise.note || '',
                video: exercise.video || '',
                day: day, // Associato al giorno
                image: exercise.image,
                muscleGroup: exercise.muscleGroup,
                numberExercise: exercise.numberExercise || '',
                muscleGroupId: exercise.id,
                isDuplicated: exercise.isDuplicated || false,
            }))
        );

        const cardioAbsExercisesData = cardioAbsExercisesList.map(exercise => ({
            name: exercise.name,
            series: exercise.series || '',
            reps: exercise.reps || '',
            rest: exercise.rest || '',
            note: exercise.note || '',
            video: exercise.video || '',
            image: exercise.image,
            muscleGroup: exercise.muscleGroup,
            numberExercise: exercise.numberExercise || '',
            muscleGroupId: exercise.id,
            isDuplicated: exercise.isDuplicated || false,
        }));

        const payload = {
            workoutPlanName,
            notes: workoutPlanNotes,
            folders: selectedFolder,
            trainerId: user.trainerId,
            exercises: exercises, // Solo esercizi del giorno
            cardioAbsExercises: cardioAbsExercisesData, // Solo esercizi di cardio/addominali
            duration: {
                value: duration,
                unit: durationUnit,
            },
        };

        try {
            let response;
            if (id) {
                response = await axios.put(`${apiUrl}/api/workoutPlans/${id}`, payload);
            } else {
                response = await axios.post(`${apiUrl}/api/workoutPlans`, payload);
            }
            if (response.status === 200) {
                message.success('Scheda salvata con successo!');
            }
        } catch (error) {
            message.error('Errore durante il salvataggio della scheda.');
        }
    };

    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Content style={{ padding: '20px' }}>
                <div className='wod'>
                    {id ? 'Modifica Scheda di Allenamento' : 'Crea una Scheda di Allenamento'}
                </div>
                {/* I campi erano Form.Item sciolti, senza un Form intorno: Ant Design
                    ripiegava sul layout orizzontale, ed erano tutti larghi in modo
                    diverso. Con layout verticale le etichette stanno sopra e i campi
                    si allineano fra loro. */}
                <Form layout="vertical">
                <Form.Item label="Nome della Scheda">
                    <Input
                        value={workoutPlanName}
                        onChange={(e) => setWorkoutPlanName(e.target.value)}
                        placeholder="Inserisci il nome della scheda"
                    />
                </Form.Item>
                <Form.Item label="Seleziona Cartelle">
                    <Select
                        mode="multiple"
                        style={{ width: '100%' }}
                        placeholder="Seleziona una o più cartelle"
                        onChange={handleFolderChange}
                        value={selectedFolder}
                    >
                        {folderOptions.map((option) => (
                            <Option key={option.value} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item label="Durata della Scheda">
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <Input
                            type="number"
                            min={1}
                            value={duration}
                            onChange={(e) => setDuration(e.target.value)}
                            placeholder="Quantità"
                            style={{ flex: '1 1 120px' }}
                        />
                        <Select
                            value={durationUnit}
                            onChange={(value) => setDurationUnit(value)}
                            style={{ flex: '1 1 140px' }}
                        >
                            <Option value="giorni">Giorno/i</Option>
                            <Option value="settimane">Settimana/e</Option>
                            <Option value="mesi">Mese/i</Option>
                        </Select>
                    </div>
                </Form.Item>
                <Form.Item label="Numero di Giorni">
                    <Input
                        type="number"
                        min={1}
                        value={numDays}
                        onChange={(e) => handleNumDaysChange(Number(e.target.value))}
                        placeholder="Inserisci il numero di giorni"
                    />
                </Form.Item>
                <Form.Item label="Note della Scheda">
                    <Input.TextArea
                        value={workoutPlanNotes}
                        onChange={(e) => setWorkoutPlanNotes(e.target.value)}
                        placeholder="Inserisci eventuali note della scheda"
                        rows={4}
                    />
                </Form.Item>
                </Form>

                {/* Sezione esercizi per ogni giorno */}
                {Array.from({ length: numDays }, (_, i) => i + 1).map((day) => (
                    <Collapse key={day} style={{ marginBottom: '10px' }}>
                        <Panel
                            header={
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>Giorno {day}</span>
                                    {numDays > 1 && (
                                        <Button
                                            type="text"
                                            danger
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                removeDay(day);
                                            }}
                                        >
                                            Rimuovi Giorno
                                        </Button>
                                    )}
                                </div>
                            }
                            key={day}
                        >
                            <Button
                                type="dashed"
                                onClick={() => openExerciseSelectionModal(day)}
                                icon={<PlusOutlined />}
                                style={{ marginBottom: '10px' }}
                            >
                                Aggiungi Esercizio
                            </Button>
                            {dayExercises[day] && dayExercises[day].length > 0 ? (
                                <List
                                    bordered
                                    dataSource={dayExercises[day]}
                                    renderItem={(exercise, index) => (
                                        <List.Item
                                            actions={[
                                                <Button
                                                    type="link"
                                                    icon={<EditOutlined />}
                                                    onClick={() => editExerciseInDay(day, index)}
                                                />,
                                                <Button
                                                    type="link"
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => removeExerciseFromDay(day, index)}
                                                />,
                                            ]}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <img
                                                    src={`/${exercise.image}`}
                                                    alt={exercise.name}
                                                    style={{ width: '40px', height: '40px', marginRight: '10px', objectFit: 'cover' }}
                                                />
                                                <span>
                                                    {exercise.name} - Serie: {exercise.series}, Ripetizioni: {exercise.reps}, Riposo: {exercise.rest}s, Note: {exercise.note}
                                                </span>
                                            </div>
                                        </List.Item>
                                    )}
                                />
                            ) : null}
                        </Panel>
                    </Collapse>
                ))}

                {/* Sezione fissa Cardio/Addominali */}
                <Collapse style={{ marginBottom: '10px' }}>
                    <Panel header="Cardio/Addominali">
                        <Button
                            type="dashed"
                            onClick={() => openExerciseSelectionModal(null, true)}
                            icon={<PlusOutlined />}
                            style={{ marginBottom: '10px' }}
                        >
                            Aggiungi Esercizio
                        </Button>
                        {cardioAbsExercisesList.length > 0 ? (
                            <List
                                bordered
                                dataSource={cardioAbsExercisesList}
                                renderItem={(exercise, index) => (
                                    <List.Item
                                        actions={[
                                            <Button
                                                type="link"
                                                icon={<EditOutlined />}
                                                onClick={() => editExerciseInDay(null, index, true)}
                                            />,
                                            <Button
                                                type="link"
                                                icon={<DeleteOutlined />}
                                                onClick={() => removeExerciseFromDay(null, index, true)}
                                            />,
                                        ]}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                                src={`/${exercise.image}`}
                                                alt={exercise.name}
                                                style={{ width: '40px', height: '40px', marginRight: '10px', objectFit: 'cover' }}
                                            />
                                            <span>
                                                {exercise.name} - Serie: {exercise.series}, Ripetizioni: {exercise.reps}, Riposo: {exercise.rest}s, Note: {exercise.note}
                                            </span>
                                        </div>
                                    </List.Item>
                                )}
                            />
                        ) : null}
                    </Panel>
                </Collapse>

                {/* Modal per selezione esercizi separati */}
                <Modal
                    title="Seleziona Esercizio"
                    open={exerciseModalVisible}
                    getContainer={document.body}
                    onCancel={() => setExerciseModalVisible(false)}
                    footer={null}
                    width={600}
                    bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
                >
                    <Collapse>
                        {isCardioAbsModal ? (
                            <>
                                <Panel header="Addominali">
                                    {absExercises.map((exercise) => (
                                        <div
                                            key={exercise.id}
                                            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginBottom: '10px' }}
                                            onClick={() => selectExercise(exercise)}
                                        >
                                            <img
                                                src={`/${exercise.image}`}
                                                alt={exercise.name}
                                                style={{ width: '50px', height: '50px', objectFit: 'cover', marginRight: '10px' }}
                                            />
                                            <span>{exercise.name}</span>
                                        </div>
                                    ))}
                                </Panel>
                                <Panel header="Cardio">
                                    {cardioExercises.map((exercise) => (
                                        <div
                                            key={exercise.id}
                                            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginBottom: '10px' }}
                                            onClick={() => selectExercise(exercise)}
                                        >
                                            <img
                                                src={`/${exercise.image}`}
                                                alt={exercise.name}
                                                style={{ width: '50px', height: '50px', objectFit: 'cover', marginRight: '10px' }}
                                            />
                                            <span>{exercise.name}</span>
                                        </div>
                                    ))}
                                </Panel>
                            </>
                        ) : (
                            muscleGroups.map((group) => (
                                <Panel header={group.group} key={group.group}>
                                    {group.exercises.map((exercise) => (
                                        <div
                                            key={exercise.id}
                                            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginBottom: '10px' }}
                                            onClick={() => selectExercise(exercise)}
                                        >
                                            <img
                                                src={`/${exercise.image}`}
                                                alt={exercise.name}
                                                style={{ width: '50px', height: '50px', objectFit: 'cover', marginRight: '10px' }}
                                            />
                                            <span>{exercise.name}</span>
                                        </div>
                                    ))}
                                </Panel>
                            ))
                        )}
                    </Collapse>
                </Modal>

                {/* Modal per i dettagli dell'esercizio */}
                <Modal
                    title="Dettagli Esercizio"
                    open={inputModalVisible}
                    getContainer={document.body}
                    onOk={addExerciseToDay}
                    onCancel={() => setInputModalVisible(false)}
                    okText="Salva Esercizio"
                    className="custom-modal"
                >
                    <Form layout="vertical">
                        <Form.Item label="Numero Esercizio in Scheda">
                            <Input
                                type="number"
                                value={exerciseDetails.numberExercise}
                                onChange={(e) =>
                                    setExerciseDetails((prev) => ({
                                        ...prev,
                                        numberExercise: e.target.value,
                                    }))
                                }
                            />
                        </Form.Item>
                        <Form.Item label="Numero di Serie">
                            <Input
                                type="number"
                                value={exerciseDetails.series}
                                onChange={(e) =>
                                    setExerciseDetails((prev) => ({
                                        ...prev,
                                        series: e.target.value,
                                    }))
                                }
                            />
                        </Form.Item>
                        <Form.Item label="Numero di Ripetizioni">
                            <Input
                                value={exerciseDetails.reps}
                                onChange={(e) =>
                                    setExerciseDetails((prev) => ({
                                        ...prev,
                                        reps: e.target.value,
                                    }))
                                }
                            />
                        </Form.Item>
                        <Form.Item label="Riposo (in secondi)">
                            <Input
                                type="number"
                                value={exerciseDetails.rest}
                                onChange={(e) =>
                                    setExerciseDetails((prev) => ({
                                        ...prev,
                                        rest: e.target.value,
                                    }))
                                }
                            />
                        </Form.Item>
                        <Form.Item label="Note">
                            <Input
                                value={exerciseDetails.note}
                                onChange={(e) =>
                                    setExerciseDetails((prev) => ({
                                        ...prev,
                                        note: e.target.value,
                                    }))
                                }
                            />
                        </Form.Item>
                    </Form>
                </Modal>
                <Button type="primary" block style={{ marginTop: '20px' }} onClick={handleSubmit}>
                    {id ? 'Aggiorna Scheda di Allenamento' : 'Salva Scheda di Allenamento'}
                </Button>
            </Content>
        </Layout>
    );
};

export default TrainerWorkoutForm;
